export default __webpack_public_path__ + "static/naan-stock-img-413ae0fb8bb4a74b9f9d8fbf01438dd5.jpg";